/** Safe, same-origin post-authentication destination handling. */
export function safeLocalReturnPath(candidate: string | null | undefined): string | null {
  const value = String(candidate ?? '').trim()
  if (!value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return null
  try {
    const parsed = new URL(value, 'https://local.invalid')
    if (parsed.origin !== 'https://local.invalid') return null
    return `${parsed.pathname}${parsed.search}${parsed.hash}`
  } catch {
    return null
  }
}

export function authReturnPath(search: string, fallback = '/app'): string {
  const params = new URLSearchParams(search)
  return safeLocalReturnPath(params.get('returnTo'))
    ?? safeLocalReturnPath(params.get('next'))
    ?? fallback
}

export function loginHref(returnTo: string): string {
  const safeReturnTo = safeLocalReturnPath(returnTo) ?? '/app'
  return `/login?returnTo=${encodeURIComponent(safeReturnTo)}`
}
